import React, { Component } from "react";
import { connect } from "react-redux";
//IMPORT COMPONENT
import Menu         from "../Components/component_Menu";
import Loader       from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";
import GoToLogin    from "../Components/component_GoToLogin";
import InputIcon    from "../Components/component_IconInput";
import PageButtons  from "../Components/component_PageButtons";
import FilterChip   from "../Components/component_FilterChips";
import BuyVersion   from "../Components/component_BuyVersion";
import SGButtonsBar from "../Components/component_SGButtonsBar";
//COMPONENTI MATERIAL UI
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup }     from "material-ui/RadioButton";
import RaisedButton                          from "material-ui/RaisedButton";
import Toggle                                from 'material-ui/Toggle';
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import DatePicker                            from "material-ui/DatePicker";
import {List, ListItem }                     from "material-ui/List"
import TextField                             from "material-ui/TextField";
import FontIcon                              from 'material-ui/FontIcon';
import Badge                                 from "material-ui/Badge";
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";

//ICON
import IconArrowUp   from "material-ui/svg-icons/navigation/arrow-drop-up";
import IconArrowDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import IconFilter    from "material-ui/svg-icons/content/filter-list";
import IconEdit      from "material-ui/svg-icons/editor/mode-edit";
import IconAdd       from "material-ui/svg-icons/content/add";
import IconDelete    from "material-ui/svg-icons/action/delete";
import IconShow      from "material-ui/svg-icons/image/remove-red-eye";
import IconRefresh   from "material-ui/svg-icons/navigation/refresh";
import IconGrid      from "material-ui/svg-icons/image/grid-on";
//ACTION
import {
  getCampiPersonalizzatiList,
  setCampoPersonalizzato,
  orderListaCampi,
  getCampiTabellaList
} from "../Actions/Action_ServiceRequest_Campi";
import { getHoldingList } from "../Actions/Action_ServiceRequest_Holding";
import { getValoriTabella, closeFillTable, handleOnTableValueChange, getValoriColonnaTabella, setValoreCampoTabella, onDeleteFieldsRow, getTabelleList } from "../Actions/Action_ServiceRequest_Tabelle";
import { getUserInfo } from "../Actions/Action_Authentication";
//Utils
import * as ROLES  from "../Utils/Roles_Types.js";
import * as STYLES from "../Utils/Styles.js";
import { checkIntForm, checkFloatForm, checkNull, checkUserLanguage } from "../Utils/Check_Value.js";
import "../CSS/style_Campi.css";
import "../CSS/style_iconTextLabel.css";
import Moment from "react-moment";
import momentformat from "moment";
//LABEL
import { LABEL_Required, LABEL_Close, LABEL_Cancel, LABEL_Filters, LABEL_Confirm, LABEL_DIALOG_DELETE_Body, LABEL_NoResult, LABEL_Deleted, LABEL_OrderBy, LABEL_Choose_Field, LABEL_Enter_MaximumValue, LABEL_FillTable, LABEL_False,
         LABEL_Filter_Either,LABEL_Filter_OnlyEditable, LABEL_PAGE_CustomFields, LABEL_Filter_OnlyDefinitive, LABEL_Filter_OnlyDeleted, LABEL_Filter_OnlyActive, 
         LABEL_Date, LABEL_Decimal, LABEL_Integer, LABEL_Table, LABEL_Text, LABEL_VeroFalso, LABEL_Choose_Value,LABEL_TableColumns, LABEL_ColumnsNotFound, LABEL_GreatherLengthOf,
         LABEL_Range, LABEL_Length, LABEL_MaxLength, LABEL_MinLength, LABEL_DefaultValue, LABEL_EditableInWeighing, LABEL_Editable, LABEL_Enter_CustomFieldName,
         LABEL_Label, LABEL_Yes, LABEL_No, LABEL_Name, LABEL_Enter_Name, LABEL_Field, LABEL_FieldType, LABEL_Enter_MaxLength, LABEL_TableStructure, LABEL_Enter_MinLength, 
         LABEL_Choose_Plant, LABEL_Choose_Company, LABEL_Choose_Holding, LABEL_Save, LABEL_Filter_OnlyMandatory, LABEL_InvalidValue, LABEL_Filter_OnlyOptional, LABEL_Enter_Length, 
         LABEL_Enter_DefaultValue, LABEL_CustomFieldTipology, LABEL_DIALOG_CustomFieldNew, LABEL_DIALOG_CustomFieldModify, LABEL_DIALOG_CustomFieldDetails, LABEL_Enter_Label,
         LABEL_MinimumValue, LABEL_TableStructureModify, LABEL_TableValuesModify, LABEL_MaximumValue, LABEL_Delete, LABEL_All, LABEL_Choose_Table, LABEL_Enter_MinimumValue, LABEL_True } from "../Utils/Strings/Labels";
import ConfirmDialog from "../Components/component_ConfirmDialog";
import { IconButton } from "material-ui";

const styles = {
  propContainer: {
    width    : 200,
    overflow : "hidden",
    margin   : "20px auto 0"
  },
  filterDialog : {
    width    : '100%',
    maxWidth : 'none'
  },
  filterRow : {
    marginBottom : '20px'
  }
};

var   TIMER         = null;
const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERIDHOLDING = USERINFO == null ? null : USERINFO.Holding ? USERINFO.Holding.ID : null;
const USERLANGUAGE  = checkUserLanguage(USERINFO);
const CANUSEPAGE    = !(!!USERINFO) ? false :  !(USERINFO.Role.ID === ROLES.ACCOUNT_FREE_ID || USERINFO.Role.ID === ROLES.ACCOUNT_PRO_ID);

var emptyCampoModel = {
  ID                   : null,
  IDTabellaSorgente    : null,
  Cancellato           : null,
  Etichetta            : null,
  Nome                 : null,
  LunghezzaUno         : null,
  LunghezzaDue         : null,
  ModificabileInPesata : true,
  Nome                 : null,
  Obbligatorio         : false,
  ValoreDefault        : null,
  IDTabella            : 0,
  TipoCampo : {
          ID   : null,
          Nome : null
  },
  Holding   : {
          ID   : USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.ID,
          Nome : USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.Nome ,
  },
}

var emptyValoreTabellaModel =   {
    Varchar : null,
    Integer : null,
    Boolean : null,
    Decimal : null,
    DateTime : null,
    Cancellato : false,
    Holding : {
      ID : null,
      Nome : null
    },
    CampoPersonalizzato : {
      ID : null,
      Nome : null,
      TipoCampo : {
        ID : null,
        Nome : null
      }
    },
    NumeroRiga: null,
    Tabella : {
      ID: null,
      Nome : null
    },
    dialogDeleteTableRowOpen : false,
  };

function generateTableRows(myArr, prop) {
    var array = [];
    var maxValue = 0;
    for(var i = 0; i<myArr.length; i++){
      var obj = myArr[i];
      if( array.indexOf(obj[prop]) == -1 ){
        array.push(obj[prop]);
        if(obj[prop] > maxValue) maxValue = obj[prop];
      }
    }
    array.push(maxValue+1);
    array = array.sort((a, b) => a - b);
    return array;
}

class CampiPersonalizzati extends Component {
  constructor(props) {
    super(props);
    //Recupero (se esiste) l'id e il nome della tabella
    var idFromUri = 0;
    var TabellaNome = null;
    var IDHoldingFromUri = null;
    if(this.props.location.search !== ""){
      var search = this.props.location.search;
      search     = search.replace("?", '');
      search     = search.split('&');
      search[0]  = search[0].split('=');
      search[1]  = search[1].split('=');
      search[2]  = search[2].split('=');
      if (search[0][0] === "ID" && search[1][0] === "Nome" && search[2][0] === "IDH") {
        idFromUri        = search[0][1];
        TabellaNome      = search[1][1];
        IDHoldingFromUri = search[2][1];
      }
    }
    //lo converto a intero
    idFromUri = !isNaN(idFromUri) ? parseInt(idFromUri) : 0; 
    emptyCampoModel.IDTabella = idFromUri;
    emptyCampoModel.Holding.ID = IDHoldingFromUri ? IDHoldingFromUri : USERIDHOLDING;
    this.state = {
      //Table
      fixedHeader         : true,
      fixedFooter         : true,
      stripedRows         : false,
      showRowHover        : true,
      selectable          : true,
      multiSelectable     : false,
      enableSelectAll     : false,
      deselectOnClickaway : false,
      showCheckboxes      : false,
      height              : "700px",
      selectedList        : [],
      //Ordinamento
      ordinaPer           : null,
      //Filter
      filter : {
        Nome         : null ,
        Etichetta    : null ,
        IDTipo       : null ,
        Modificabile : null ,
        Obbligatorio : null ,
        Cancellato   : false ,
        IDHolding    : IDHoldingFromUri || (USERINFO.Holding != null ? USERINFO.Holding.ID : null), //Non puo essere inserito dall'utene,
        IDTabella    : idFromUri
      },
      //Modal per la visualizzazione del dettaglio
      showDetails : {
        opened : false
      },
      //Modal per aggiungere o modificare un campo personalizzato
      showAddModify : {
        opened : false,
        data   : JSON.parse(JSON.stringify(emptyCampoModel))
      },
      filterDialog : {
        opened : false,
        data : null //Lo utilizzo per salvare i movimenti nella dialog cosi che se vengono annullati rimane tutto come prima
      },
      filterHolding : {
        ID : null,
        Nome : null,
        Descrizione : null,
        DataInizioScadenza : null,
        DataFineScadenza : null
      },
      ToRefreshOnRender   : false,
      NomeTabella         : TabellaNome,
      IdTabella           : idFromUri,
      dialogSelectTableValue : {
        opened : false,
        onConfirm : () => null,
        onCancel  : () => this.setState({dialogSelectTableValue : {opened: false, onCancel: this.state.dialogSelectTableValue.onCancel}})
      },
      filterChipsList : []
    };
  }

  
  setTimerForText = () => {
    if(TIMER != null)
      clearTimeout(TIMER);
    TIMER = setTimeout(() => {
      this.props.dispatch(getCampiPersonalizzatiList(this.state.filter));
    }, 500);
  }

  isSelectedRow = index => this.state.selectedList.indexOf(index) !== -1;

  handleRowSelection = row   => this.setState({ selectedList : row , selectedObj : this.props.campiPersonalizzatiList[row]})

  handleChangeHolding = (event, index, value) => {
    var filter = this.state.filter;
    filter.IDHolding = value;
    this.setState( { filter : filter } );
    this.props.dispatch(getCampiPersonalizzatiList(this.state.filter));
  }

  //Dialog visualizzazione dettagli
  handleOpenShowDetails = () => {
    var show = this.state.showDetails;
    show.opened = true;
    this.setState({showDetails : show});
  };
  handleCloseShowDetails = () => {
    var showDetails = this.state.showDetails;
    showDetails.opened = false;
    this.setState( { showDetails : showDetails } );
  };

  //Dialog aggiunta modifica campo personalizzato
  handleOpenAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = true;
    if(this.state.selectedList.length === 1){
      var x = this.props.campiPersonalizzatiList[this.state.selectedList[0]];
      var data = JSON.parse(JSON.stringify(this.props.campiPersonalizzatiList[this.state.selectedList[0]]));
      if(data.TipoCampo.ID === 3) // boolean
        data.ValoreDefault = data.ValoreDefault === "True";
    }else{
      data = JSON.parse(JSON.stringify(emptyCampoModel));
      if (data.Holding.ID == null) data.Holding.ID = this.state.filter.IDHolding;
    }
    console.log(data);

    showAddModify.data = data;
    if(data.IDTabellaSorgente !== null )
      this.props.dispatch(getCampiTabellaList({IDHolding: this.state.filter.IDHolding, IDTabella: data.IDTabellaSorgente}));

    this.props.dispatch(getTabelleList({IDHolding: this.state.filter.IDHolding}));
    
    this.setState({showAddModify : showAddModify});
  };
  handleCloseAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = false;
    this.setState( { showAddModify : showAddModify } );
  };
  handleCloseAddModifyWithSave = () => {    
    //Controllo i campi
    var flag = true;
    var showAddModify = this.state.showAddModify;
    var data = showAddModify.data;
    var tipoCampo = data.TipoCampo.ID
    var isNumber = tipoCampo == 2 || tipoCampo == 4;
    var isText   = tipoCampo == 1;
    
    if(checkNull(data.Nome)){
      data.msgErrorNome = LABEL_Required[USERLANGUAGE];
      flag = false;
    }else data.msgErrorNome = "";
    if(checkNull(data.Etichetta)){
      data.msgErrorEtichetta = LABEL_Required[USERLANGUAGE];
      flag = false;
    }else data.msgErrorEtichetta = "";
    if(checkNull(tipoCampo)){
      data.msgErrorTipoCampo = LABEL_Required[USERLANGUAGE];
      flag = false;
    }else data.msgErrorTipoCampo = "";

    if(isNumber){
      data.msgErrorLunghezzaUno  = tipoCampo == 4 ? checkFloatForm(data.LunghezzaUno) : checkIntForm(data.LunghezzaUno);
      if(data.msgErrorLunghezzaUno != null ) flag = false;
      
      if(data.LunghezzaDue != null){
        data.msgErrorLunghezzaDue  = tipoCampo == 4 ? checkFloatForm(data.LunghezzaDue) : checkIntForm(data.LunghezzaDue);
        if(data.msgErrorLunghezzaDue != null ) flag = false;
      }else data.msgErrorLunghezzaDue = "";

      //se non ci sono errori allora viene controllato che il secondo deve essere maggiore o uguale del primo 
      var parseUno = parseFloat(data.LunghezzaUno);
      var parseDue = parseFloat(data.LunghezzaDue);
      
      if( (data.msgErrorLunghezzaUno == null && data.msgErrorLunghezzaDue == null)){
        if( !isNaN(parseUno) && ( parseDue < parseUno ) ){
          data.msgErrorLunghezzaDue = LABEL_InvalidValue[USERLANGUAGE];
          flag = false;
        }else data.msgErrorLunghezzaDue = null;

        if( data.msgErrorLunghezzaDue == null ){ // Se non ci sono problemi controllo il valore di default c
          if( data.ValoreDefault != null ){
            var parseValoreDefault = parseFloat(data.ValoreDefault);
            if(isNaN(parseValoreDefault) || (parseValoreDefault < parseUno || parseValoreDefault > parseDue)){
              data.msgErrorValoreDefault = LABEL_InvalidValue[USERLANGUAGE];
              flag = false;
            }else data.msgErrorValoreDefault = null;
          }
        }
      }
    }

    if(isText){
      data.msgErrorLunghezzaUno = checkIntForm(data.LunghezzaUno);
      if( !checkNull(data.msgErrorLunghezzaUno) ) flag = false;
      else if( !checkNull(data.ValoreDefault) ){  //Controllo se il valore di default inserito e' piu lungo della lunghezz inserita
        data.msgErrorValoreDefault = data.ValoreDefault.length > parseInt(data.LunghezzaUno) ? LABEL_GreatherLengthOf[USERLANGUAGE]+data.LunghezzaUno : null;
        if( !checkNull(data.msgErrorValoreDefault) ) flag = false;
      }
    }

    if(data.Holding == null || data.Holding.ID == null) //forzo l'holding (cosi da non perdere traccia del campo aggiunto)
      data.Holding = USERINFO.Holding;

    showAddModify.data = data;
    if(flag){
      showAddModify.opened = false;
      this.props.dispatch(setCampoPersonalizzato(showAddModify.data));//mando al servizio i dati
      setTimeout(() => this.props.dispatch(getCampiPersonalizzatiList(this.state.filter)), 150);
    }else this.setState( { showAddModify : showAddModify } );
  }
  handleAddModifyTipoCampoChange = (event, index, value) => {
    var showAddModify      = this.state.showAddModify;
    var data               = showAddModify.data;
    data.TipoCampo.ID      = value;
    data.msgErrorTipoCampo = "";
    data.ValoreDefault     = null;
    data.LunghezzaUno      = null;
    data.LunghezzaDue      = null;
    showAddModify.data     = data;
    this.setState( { showAddModify : showAddModify } );
  }
  handleOnToggleAddModify = (obj, checked, position) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data[position] = checked;
    this.setState( { showAddModify : showAddModify } );
  }
  handleOnChangeAddModifyText = (value, position) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data[position] = value;
    this.setState( { showAddModify : showAddModify } );
  }
  handleOnChangeAddModifyTabella = (event, index, value) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data.IDTabellaSorgente = value;
    this.setState({showAddModify});
    this.props.dispatch(getCampiTabellaList({IDHolding: this.state.filter.IDHolding, IDTabella: value}));
  }
  handleOnChangeAddModifyCampo = (event, index, value) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data.IDColonna = value;
    console.log(value);
    this.setState({showAddModify});
  }
  //Per intercettare il cambio di filtri testuali
  handleOnFilterTextChange = (value, position, label) => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[position] = value;
    filterChips[position] = {position : position, value : value, label : label };
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  };

  handleDeleteButton = () => this.setState({showDeleteDialog: true})

  _deleteRow = () =>{
    if (this.state.selectedList[0] > this.props.campiPersonalizzatiList.length) {
      this.setState({ selectedList: [] });
      return;
    }
    var showAddModify = this.props.campiPersonalizzatiList[this.state.selectedList[0]];
      showAddModify.Cancellato = true;
    if (this.state.selectedList[0] == this.props.campiPersonalizzatiList.length -1) // se era l'ultimo
      this.setState({ selectedList: [] , showDeleteDialog : false});
    this.props.dispatch(setCampoPersonalizzato(showAddModify));
    setTimeout( () => this.props.getCampiPersonalizzatiList(this.state.filter) , 150);
  }

  handleOrderChange = (event, index, value) => {
    this.setState({ordinaPer : value});
    this.props.dispatch(orderListaCampi(this.props.campiPersonalizzatiList, value))
  }

  //FILTER DIALOG
  handleOpenFilterDialog = () => {
    var filterDialog = this.state.filterDialog;
    filterDialog.opened = true;
    filterDialog.data   = JSON.parse(JSON.stringify(this.state.filter));
    var data            = filterDialog.data;
    data.Modificabile = data.Modificabile === null ? -1 : Number(data.Modificabile);
    data.Obbligatorio = data.Obbligatorio === null ? -1 : Number(data.Obbligatorio);
    data.Cancellato   = data.Cancellato   === null ? -1 : Number(data.Cancellato  );
    filterDialog.data = data;
    this.setState({filterDialog : filterDialog});
  };
  handleCloseFilterDialog = () => {
    var filterDialog    = this.state.filterDialog;
    filterDialog.opened = false;
    filterDialog.data   = null;
    this.setState({filterDialog : filterDialog});
  };
  handleCloseFilterDialogWithSave = () => {
    var filterDialog               = this.state.filterDialog;
    filterDialog.opened            = false;
    var data = filterDialog.data;
    data.Modificabile = data.Modificabile == -1 ? null : !!data.Modificabile;
    data.Obbligatorio = data.Obbligatorio == -1 ? null : !!data.Obbligatorio;
    data.Cancellato   = data.Cancellato   == -1 ? null : !!data.Cancellato;
    filterDialog.data = data;
    this.setState({filter : filterDialog.data});
    this.props.dispatch(getCampiPersonalizzatiList(filterDialog.data));
  };
  //Funzione per l'evento nel toggle dei filtri
  handleFilterToggle = (event, toggle, position, label) => {
    var filterChips = this.state.filterChipsList;
    var filterDialog = this.state.filterDialog;
    filterDialog.data[position] = toggle;
    filterChips[position] = {position : position, value : toggle, label : label };
    this.setState({filterDialog : filterDialog});
  }

  componentDidMount = () => {
    this.props.dispatch(getUserInfo());
     if(this.state.filter.IDHolding === null && this.state.NomeTabella === null){
      this.props.dispatch(getHoldingList(this.state.filterHolding));
    }else{
      this.props.dispatch(getCampiPersonalizzatiList(this.state.filter));
    }
  }

  fillTableOpen = () => {
    this.props.dispatch(getValoriTabella(this.state.filter))
  }
  fillTableClose = () => {
    this.props.dispatch(closeFillTable());
  }
  fillTableCloseWithSave = () => {
    this.props.dispatch(setValoreCampoTabella(this.props.campiTabellaList, this.props.campiTabellaModifyIndexes));
    this.props.dispatch(closeFillTable());
  }

  _getCampoValue(campo){
    switch(campo.CampoPersonalizzato.TipoCampo.ID){
        case 1: return campo.Varchar;
        case 2: return campo.Integer;
        case 3: return campo.Boolean;
        case 4: return campo.Decimal;
        case 5: 
          var x = campo.DateTime;
          var mom = momentformat(campo.DateTime);
          if(!mom.isValid()) return null;
          else mom = mom.format("YYYY-MM-DD");
          var date = new Date(mom);
          return date;
        default : return campo.Varchar;
      }
  }

  getValueFromCampo(IDCampo, numeroRiga, col){
    var campo = this._getCampoFromList(IDCampo, numeroRiga, col);
    if( campo === null ) return null;
    return this._getCampoValue(campo);
  }

  _getCampoFromList(IDCampo, numeroRiga, col){
    var index = -1;
    for(var i = 0; i<this.props.campiTabellaList.length; i++){
      var tmp = this.props.campiTabellaList[i];
      if( tmp.CampoPersonalizzato.ID === IDCampo && tmp.NumeroRiga === numeroRiga )
        index = i;
    }
    if( index == -1 )return null;
    return this.props.campiTabellaList[index];
  }

  

  getErrorFormCampo(IDCampo, numeroRiga, col){
    var index = -1;
    for(var i = 0; i<this.props.campiTabellaList.length; i++){
      var tmp = this.props.campiTabellaList[i];
      if( tmp.CampoPersonalizzato.ID === IDCampo && tmp.NumeroRiga === numeroRiga )
        index = i;
    }
    
    if( index == -1 ) return null;
    return this.props.campiTabellaList[index].Error;
  }

  onSelectTableValue = (campiList, campo, row) => {
    this.props.dispatch(getValoriColonnaTabella({IDHolding: campo.Holding.ID, IDTabella: campo.IDTabellaSorgente, IDColonna: campo.IDColonna}))
    var dialogSelectTableValue = this.state.dialogSelectTableValue;
    dialogSelectTableValue.opened = true;
    dialogSelectTableValue.onConfirm = () => {
      this.props.dispatch(handleOnTableValueChange(campiList, this.state.dialogSelectTableValue.selected, campo, row ));
      this.state.dialogSelectTableValue.onCancel();
      this.forceUpdate();
    };
    dialogSelectTableValue.selected = null;
    dialogSelectTableValue.onValueChange = (value) => {
      var d = this.state.dialogSelectTableValue;
      d.selected = value;
      d.opened = false;
      this.setState({dialogSelectTableValue : d});
      this.props.dispatch(handleOnTableValueChange(campiList, value, campo, row ));
    }
    setTimeout( () => {
    dialogSelectTableValue.body = 
      (
        <div>
          <List>
                {this.props.tableColumnValues.map( value => {
                  var val = this._getCampoValue(value);
                  return (<ListItem onClick={() => this.state.dialogSelectTableValue.onValueChange(val)}>
                    {val}
                  </ListItem>)
                  }
                )
                }
                
          </List>
        </div>
      );
    this.setState({dialogSelectTableValue : dialogSelectTableValue})
    }, 500);
  }

  _rowIsDeleted = indexRow => {
    var numeroColonne = 0;
    var numeroEliminate = 0;
    this.props.campiTabellaList.forEach( item => {
      if(item.NumeroRiga === indexRow){
        if(item.Cancellato === true)
          numeroEliminate++;
        numeroColonne++;
      }
    })
    return numeroColonne <= numeroEliminate;
  }

  onDeleteChips = chip => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[chip.position] = null;
    filterChips[chip.position] = null;
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  }

  render() {
    console.log(this.props.campiTabellaList)
    var rowGeneratedTable = generateTableRows(this.props.campiTabellaList, "NumeroRiga");

    if(this.props.toRefreshOnRender)
      this.props.dispatch(getCampiPersonalizzatiList(this.state.filter));

    //Tasti per la showDetails
    const showDetailDialogActions = [
      <RaisedButton
        label={LABEL_Close[USERLANGUAGE]}
        primary={true}
        onClick={this.handleCloseShowDetails}
      />,
    ];

    //Tasti per la dialog aggiungi/modifica
    const addModifyDialogAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={this.handleCloseAddModify}
      />,
      <RaisedButton
        label={LABEL_Save[USERLANGUAGE]}
        primary={true}
        onClick={this.handleCloseAddModifyWithSave}
      />
    ];

    //Tasti per la dialog filtri
    const filterDialogAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={this.handleCloseFilterDialog}
      />,
      <RaisedButton
        label={LABEL_Save[USERLANGUAGE]}
        primary={true}
        onClick={this.handleCloseFilterDialogWithSave}
      />
    ];

    const fillTableAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={this.fillTableClose}
      />,
      <RaisedButton
        label={LABEL_Save[USERLANGUAGE]}
        primary={true}
        onClick={this.fillTableCloseWithSave}
      />
    ];

    const menuButtons = [];

    //AGGIUNGI
    if(this.state.selectedList.length === 0 && USERINFO.Role.ID != ROLES.OPERATOR_ID )
      menuButtons.push( <RaisedButton className="button-table" icon={<IconAdd/>} onClick={this.handleOpenAddModify} buttonStyle={STYLES.sg_Button} /> );
    //MODIFICA
    if(this.state.selectedList.length === 1 && USERINFO.Role.ID != ROLES.OPERATOR_ID) 
      menuButtons.push( <RaisedButton className="button-table" icon={<IconEdit />} onClick={this.handleOpenAddModify} buttonStyle={STYLES.sg_Button} /> );
    //ELimina
    if(this.state.selectedList.length > 0 && USERINFO.Role.ID != ROLES.OPERATOR_ID)
      menuButtons.push( <RaisedButton className="button-table" icon={<IconDelete />} onClick={this.handleDeleteButton} buttonStyle={STYLES.sg_Button} /> );
    //VISUALIZZA DETTAGLIO
    if(this.state.selectedList.length === 1 )
      menuButtons.push( <RaisedButton className="button-table" icon={<IconShow />} onClick={this.handleOpenShowDetails} buttonStyle={STYLES.sg_Button} /> );
    

    var buttonBarList = [];
    if(USERINFO.Role.ID != ROLES.OPERATOR_ID){
      buttonBarList = [
        { //AGGIUNGI
          icon     : <IconAdd />, 
          onClick  : this.handleOpenAddModify,
          disabled : this.state.selectedList.length > 0 ,
        },
        { //MODIFICA
          icon     : <IconEdit />, 
          onClick  : this.handleOpenAddModify,
          disabled : this.state.selectedList.length !== 1,
        },
        { //ELIMINA
          icon     : <IconDelete />, 
          onClick  : this.handleDeleteButton,
          disabled : this.state.selectedList.length < 1,
        },
        
      ]
    }
    buttonBarList.push({ //VISUALIZZA DETTAGLIO
      icon     : <IconShow />, 
      onClick  : this.handleOpenShowDetails,
      disabled : this.state.selectedList.length !== 1
    });
    buttonBarList.push({ //REFRESH
      icon     : <IconRefresh />, 
      onClick  : () => this.props.dispatch(getCampiPersonalizzatiList(this.state.filter))
    });

    var buttonBarListTable = [];
    if( this.state.filter.IDTabella != 0 ){
      buttonBarListTable.push({
          icon     : <IconGrid />, 
          onClick  : this.fillTableOpen ,
          disabled : this.state.selectedList.length !== 0,
        });
    }

    var _Selected    = this.state.selectedList[0];
    var _SelectedEl  = this.props.campiPersonalizzatiList[_Selected];
    var _AddMod_Data = this.state.showAddModify.data;
    return (
      <div >
        <Menu 
          dispatch               = {this.props.dispatch}
          pageName               = {this.state.NomeTabella === null ? LABEL_PAGE_CustomFields[USERLANGUAGE] : LABEL_TableStructure[USERLANGUAGE]+this.state.NomeTabella}
          backAddress            = {this.state.NomeTabella === null ? null : "/tabelle"} 
          rightNavButtonIcon     ={!CANUSEPAGE ? null : <IconFilter/>}
          rightNavButtonFunction ={this.handleOpenFilterDialog}
          Language={USERLANGUAGE} />
          <Loader       isFetching      = {this.props.isFetching}      />
          <ErrorMessage message         = {this.props.errorMessage}    />
          <GoToLogin    isAuthenticated = {this.props.isAuthenticated} />
          <BuyVersion 
            visible={!CANUSEPAGE}
            Language={USERLANGUAGE}/>
          <div className="my-body">
            { USERIDHOLDING == null && this.state.filter.IDTabella == 0 && 
              <SelectField
                  floatingLabelText={LABEL_Choose_Holding[USERLANGUAGE]}
                  value={this.state.filter.IDHolding}
                  onChange={this.handleChangeHolding}>
                    {  this.props.holdingList && this.props.holdingList.map( holding => <MenuItem key={holding.ID} value={holding.ID} primaryText={holding.Nome}/>  ) }
              </SelectField>
            }
            { this.state.filter.IDHolding != null &&
              <div>
                <Grid>
                  <Row style={styles.filterRow}>
                    <Col xs4={4} sm12={4} lg12={4} xl12={4}>
                      <InputIcon
                        icon              = {<IconFilter/>}
                        class             = "input-label"
                        onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Nome",  LABEL_Name[USERLANGUAGE]) }
                        hintText          = {LABEL_Enter_CustomFieldName[USERLANGUAGE]}
                        floatingLabelText = {LABEL_Name[USERLANGUAGE]}
                        value             = {this.state.filter.Nome == null ? "" : this.state.filter.Nome}
                      />
                       
                    </Col>
                    <Col xs4={4} sm12={4} lg12={4} xl12={4}>
                        <InputIcon 
                            icon              = {<IconFilter/>}
                            className         = "input-label"
                            onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Etichetta", LABEL_Label[USERLANGUAGE] ) }
                            hintText          = {LABEL_Enter_Label[USERLANGUAGE]}
                            floatingLabelText = {LABEL_Label[USERLANGUAGE]}
                            value             = {this.state.filter.Etichetta == null ? "" : this.state.filter.Etichetta}/>
                    </Col>
                    <Col xs4={4} sm12={4} lg12={4} xl12={4}>
                    <SelectField
                          floatingLabelText={LABEL_OrderBy[USERLANGUAGE]}
                          value={this.state.ordinaPer}
                          onChange={this.handleOrderChange}
                        >
                          <MenuItem value = { "Nome"          } primaryText = { LABEL_Name[USERLANGUAGE]    } rightIcon = { <IconArrowUp   /> } />
                          <MenuItem value = { "NomeDESC"      } primaryText = { LABEL_Name[USERLANGUAGE]    } rightIcon = { <IconArrowDown /> } />
                          <MenuItem value = { "Etichetta"     } primaryText = { LABEL_Label[USERLANGUAGE]   } rightIcon = { <IconArrowUp   /> } />
                          <MenuItem value = { "EtichettaDESC" } primaryText = { LABEL_Label[USERLANGUAGE]   } rightIcon = { <IconArrowDown /> } />
                          <MenuItem value = { "Cancellata"    } primaryText = { LABEL_Deleted[USERLANGUAGE] } rightIcon = { <IconArrowUp   /> } />
                          <MenuItem value = { "CancellataDESC"} primaryText = { LABEL_Deleted[USERLANGUAGE] } rightIcon = { <IconArrowDown /> } />
                        </SelectField>
                    </Col>
                     
                  </Row>
                  {/*this.state.NomeTabella === null*/}
                  
                  
                  
                  { 
                    <Row>
                        <div className="button-title">{LABEL_TableStructureModify[USERLANGUAGE]}</div>
                        <SGButtonsBar list={buttonBarList}/>
                    </Row>}
                    {
                      this.state.NomeTabella !== null && USERINFO.Role.ID != ROLES.OPERATOR_ID && this.state.filter.IDTabella != 0 && 
                      <Row>
                        <div className="button-title">{LABEL_TableValuesModify[USERLANGUAGE]}</div>
                        { //SE SI E' IN CAMPI PER TABELLA ALLORA VISUALIZZO 
                           <SGButtonsBar list={buttonBarListTable}/>
                        }
                      </Row>
                    }
                </Grid>

                <FilterChip
                  list = {this.state.filterChipsList}
                  onDelete = {this.onDeleteChips}
                />

                <Table
                  className       = "shadow"
                  height          = { (window.innerHeight - 500) +"px" }
                  fixedHeader     = { this.state.fixedHeader}
                  fixedFooter     = { this.state.fixedFooter}
                  selectable      = { this.state.selectable}
                  multiSelectable = { this.state.multiSelectable}
                  onRowSelection  = { this.handleRowSelection}
                  >

                <TableHeader
                    displaySelectAll  = { this.state.showCheckboxes  }
                    adjustForCheckbox = { this.state.showCheckboxes  }
                    enableSelectAll   = { this.state.enableSelectAll }>
                      <TableRow>
                        <TableHeaderColumn style={{width: "40%"}}  tooltip="">{this.state.NomeTabella === null ? LABEL_Name[USERLANGUAGE]+" "+LABEL_Field[USERLANGUAGE] : LABEL_TableColumns[USERLANGUAGE]} </TableHeaderColumn>
                        <TableHeaderColumn style={{width: "35%"}}  tooltip="">{LABEL_Label[USERLANGUAGE]}    </TableHeaderColumn>
                        <TableHeaderColumn style={{width: "35%"}}  tooltip="">{LABEL_FieldType[USERLANGUAGE]}</TableHeaderColumn>
                        <TableHeaderColumn style={{width: "10%"}}  tooltip="">{LABEL_Editable[USERLANGUAGE]} </TableHeaderColumn>
                        <TableHeaderColumn style={{width: "10%"}}  tooltip="">{LABEL_Required[USERLANGUAGE]} </TableHeaderColumn>
                        <TableHeaderColumn style={{width: "10%"}}  tooltip="">{LABEL_Deleted[USERLANGUAGE]}  </TableHeaderColumn>
                      </TableRow>
                  </TableHeader>
                  <TableBody
                      displayRowCheckbox  = {this.state.showCheckboxes}
                      deselectOnClickaway = {this.state.deselectOnClickaway}
                      showRowHover        = {this.state.showRowHover}
                      stripedRows         = {this.state.stripedRows}
                    >
                      {
                        this.props.campiPersonalizzatiList.map( (row, index) => {
                          var isSelected = this.isSelectedRow(index);
                          return (
                          <TableRow key={index} selected={isSelected} style={{background: isSelected === true ? "blue!important" : "none"}}>
                            <TableRowColumn style={{width: "40%"}} > { row.Nome                                                                                        } </TableRowColumn>
                            <TableRowColumn style={{width: "35%"}} > { row.Etichetta                                                                                   } </TableRowColumn>
                            <TableRowColumn style={{width: "35%"}} > { row.TipoCampo.ID > 5 ? row.TipoCampo.Nome+" ("+row.TabellaSorgenteNome+")" : row.TipoCampo.Nome } </TableRowColumn>
                            <TableRowColumn style={{width: "10%"}} > { row.ModificabileInPesata ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE]                                                 } </TableRowColumn>
                            <TableRowColumn style={{width: "10%"}} > { row.Obbligatorio         ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE]                                                 } </TableRowColumn>
                            <TableRowColumn style={{width: "10%"}} > { row.Cancellato           ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE]                                                 } </TableRowColumn>
                          </TableRow>)
                        })
                      }
                      {
                        this.props.campiPersonalizzatiList.length === 0 &&
                        <TableRow selectable={false} hoverable={false} hovered={false} selectable={false} striped={false}>
                          <TableRowColumn><center>{LABEL_NoResult[USERLANGUAGE]}</center></TableRowColumn>
                        </TableRow>
                      }
                    </TableBody>
                </Table>
              </div>
            }
            {/* Per la visualizzare il modal per la visualizzazione senza modifica*/}
            <Dialog
              title={LABEL_DIALOG_CustomFieldDetails[USERLANGUAGE]}
              actions={showDetailDialogActions}
              modal={true}
              contentStyle={styles.filterDialog}
              open={this.state.showDetails.opened || false}
            >
              {
                typeof _SelectedEl !== 'undefined' /*Per gestire le rederizzazioni con la lista vuota*/&&
                <Grid>
                  {/*NOME*/}
                  <Row className="line-bottom">
                    <Col xs4={1}> {LABEL_Name[USERLANGUAGE]} : </Col>
                    <Col xs4={3}> { _SelectedEl.Nome } </Col>
                  </Row>
                  {/*ETICHETTA*/}
                  <Row className="line-bottom">
                    <Col xs4={1}> {LABEL_Label[USERLANGUAGE]} : </Col>
                    <Col xs4={3}> { _SelectedEl.Etichetta } </Col>
                  </Row>
                  {/*Tipo Campo*/}
                  <Row className="line-bottom">
                    <Col xs4={1}> {LABEL_CustomFieldTipology[USERLANGUAGE]} : </Col>
                    <Col xs4={3}> { _SelectedEl.TipoCampo.Nome } </Col>
                  </Row>
                  {/*VALORE MIN MAX, viene visualizzato il range per i tipi INTERO, DECIMALE, mentre per il campo TESTO solo la lunghezza massima */                    
                    (
                      _SelectedEl.TipoCampo.ID === 2 ||  //INTERO
                      _SelectedEl.TipoCampo.ID === 4     //DECIMALE
                    ) && 
                    <Row className="line-bottom">
                      <Col xs4={1}> {LABEL_Range[USERLANGUAGE]} : </Col>
                      <Col xs4={1}> Min: {_SelectedEl.LunghezzaUno} </Col>
                      <Col xs4={1}> Max: {_SelectedEl.LunghezzaDue} </Col>
                      
                    </Row>
                    || _SelectedEl.TipoCampo.ID === 1 && //TESTO
                    <Row className="line-bottom">
                      <Col xs4={1}> {LABEL_MaxLength[USERLANGUAGE]} : </Col>
                      <Col xs4={3}> {_SelectedEl.LunghezzaUno} </Col>
                    </Row>
                    || _SelectedEl.TipoCampo.ID  === 3    && //BOOLEAN
                       _SelectedEl.ValoreDefault != null &&
                    <Row className="line-bottom">
                      <Col xs4={1}> 
                        <Toggle
                          label    = {LABEL_DefaultValue[USERLANGUAGE]}
                          style    = { styles.toggle }
                          toggled  = { _SelectedEl.ValoreDefault === "True" }
                        /></Col>
                    </Row>
                  }
                  {//Valore di default
                    (
                      _SelectedEl.TipoCampo.ID !== 5 ||  //DATA
                      _SelectedEl.TipoCampo.ID !== 6 &&  //TABELLA
                      _SelectedEl.ValoreDefault !== null
                    ) &&
                    <Row className="line-bottom">
                      <Col xs4={1}> {LABEL_DefaultValue[USERLANGUAGE]} : </Col>
                      <Col xs4={3}> {_SelectedEl.ValoreDefault} </Col>
                    </Row>
                  }
                  {/*MODIFICABILE IN PESATA*/}
                  <Row className="line-bottom">
                    <Col xs4={1}> {LABEL_EditableInWeighing[USERLANGUAGE]} : </Col>
                    <Col xs4={3}> {_SelectedEl.ModificabileInPesata ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE]} </Col>
                  </Row>
                  {/*OBBLIGATORIO*/}
                  <Row className="line-bottom">
                    <Col xs4={1}> {LABEL_Required[USERLANGUAGE]} : </Col>
                    <Col xs4={3}> {_SelectedEl.Obbligatorio ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE]} </Col>
                  </Row>
                  {/*OBBLIGATORIO*/}
                  <Row className="line-bottom">
                    <Col xs4={1}> {LABEL_Deleted[USERLANGUAGE]} : </Col>
                    <Col xs4={3}> {_SelectedEl.Cancellato ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE]} </Col>
                  </Row>
                </Grid>
              }
            </Dialog>

            {/* Per la visualizzare il modal per la visualizzazione senza modifica*/}
            <Dialog
              title={this.state.selectedList.length === 0 ? LABEL_DIALOG_CustomFieldNew[USERLANGUAGE] : LABEL_DIALOG_CustomFieldModify[USERLANGUAGE]}
              actions={addModifyDialogAction}
              modal={true}
              contentStyle={styles.filterDialog}
              open={this.state.showAddModify.opened || false}
            >
              <Grid>
                <Row>
                  <Col xs4={2}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Nome")}
                      hintText={LABEL_Enter_Name[USERLANGUAGE]}
                      floatingLabelText={LABEL_Enter_Name[USERLANGUAGE]}
                      errorText={_AddMod_Data.msgErrorNome}
                      value={ _AddMod_Data.Nome === null  ? "" : _AddMod_Data.Nome }/>
                  </Col>
                  <Col xs4={2}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Etichetta")}
                      hintText={LABEL_Enter_Label[USERLANGUAGE]}
                      floatingLabelText={LABEL_Label[USERLANGUAGE]}
                      errorText={_AddMod_Data.msgErrorEtichetta}
                      value={ _AddMod_Data.Etichetta === null  ? "" : _AddMod_Data.Etichetta }/>
                  </Col>
                </Row>
                <Row>
                  <Col xs4={1}>
                    <SelectField
                        floatingLabelText = { LABEL_CustomFieldTipology[USERLANGUAGE]                       }
                        value             = { _AddMod_Data.TipoCampo.ID      }
                        onChange          = { this.handleAddModifyTipoCampoChange             }
                        errorText         = { _AddMod_Data.msgErrorTipoCampo }
                      >
                      <MenuItem value = { 5 } primaryText = { LABEL_Date[USERLANGUAGE]     } />
                      <MenuItem value = { 4 } primaryText = { LABEL_Decimal[USERLANGUAGE]  } />
                      <MenuItem value = { 2 } primaryText = { LABEL_Integer[USERLANGUAGE]  } />
                      <MenuItem value = { 6 } primaryText = { LABEL_Table[USERLANGUAGE]    } />
                      <MenuItem value = { 1 } primaryText = { LABEL_Text[USERLANGUAGE]     } />
                      <MenuItem value = { 3 } primaryText = { LABEL_VeroFalso[USERLANGUAGE]} />
                    </SelectField>
                  </Col>
                  
                </Row>
                {/*VALORE MIN MAX, viene visualizzato il range per i tipi INTERO, DECIMALE, mentre per il campo TESTO solo la lunghezza massima  */   
                    (
                      _AddMod_Data.TipoCampo.ID === 2 ||  //INTERO
                      _AddMod_Data.TipoCampo.ID === 4     //DECIMALE
                    ) && 
                    <Row>
                      <Col xs4={1}> 
                        <TextField className="input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText(event.target.value, "LunghezzaUno")}
                          hintText          = { LABEL_Enter_MinimumValue[USERLANGUAGE]}
                          floatingLabelText = { LABEL_MinimumValue[USERLANGUAGE]}
                          errorText         = { _AddMod_Data.msgErrorLunghezzaUno}
                          value             = { checkNull(_AddMod_Data.LunghezzaUno) ? "" : _AddMod_Data.LunghezzaUno }/>
                      </Col>
                      <Col xs4={1}> 
                        <TextField className="input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText(event.target.value, "LunghezzaDue")}
                          hintText          = { LABEL_Enter_MaximumValue[USERLANGUAGE]}
                          floatingLabelText = { LABEL_MaximumValue[USERLANGUAGE]}
                          errorText         = { _AddMod_Data.msgErrorLunghezzaDue}
                          value             = { checkNull(_AddMod_Data.LunghezzaDue) ? "" : _AddMod_Data.LunghezzaDue }/> 
                      </Col>
                      <Col xs4={1}>
                        <TextField className="input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText(event.target.value, "ValoreDefault")}
                          hintText          = { LABEL_Enter_DefaultValue[USERLANGUAGE]}
                          floatingLabelText = { LABEL_DefaultValue[USERLANGUAGE]}
                          errorText         = { _AddMod_Data.msgErrorValoreDefault}
                          value             = { checkNull(_AddMod_Data.ValoreDefault) ? "" : _AddMod_Data.ValoreDefault }/>
                      </Col>
                    </Row>
                    || _AddMod_Data.TipoCampo.ID === 1 && //TESTO
                    <Row>
                      <Col xs4={3}> 
                        <TextField className="input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText(event.target.value, "LunghezzaUno")}
                          hintText          = { LABEL_Enter_Length[USERLANGUAGE]}
                          floatingLabelText = { LABEL_Length[USERLANGUAGE]}
                          errorText         = { _AddMod_Data.msgErrorLunghezzaUno}
                          value             = { checkNull(_AddMod_Data.LunghezzaUno) ? "" : _AddMod_Data.LunghezzaUno }/>
                      </Col>
                      <Col xs4={1}>
                        <TextField className="input-label"
                          onChange          = { event => this.handleOnChangeAddModifyText(event.target.value, "ValoreDefault")}
                          hintText          = { LABEL_Enter_DefaultValue[USERLANGUAGE]}
                          floatingLabelText = { LABEL_DefaultValue[USERLANGUAGE]}
                          errorText         = { _AddMod_Data.msgErrorValoreDefault}
                          value             = { checkNull(_AddMod_Data.ValoreDefault) ? "" : _AddMod_Data.ValoreDefault }/>
                      </Col>
                    </Row>
                    || _AddMod_Data.TipoCampo.ID === 3 && //BOOLEAN
                    <Row className="line-bottom">
                      <Col xs4={1}>
                        <SelectField
                            floatingLabelText={LABEL_DefaultValue[USERLANGUAGE]}
                            value={_AddMod_Data.ValoreDefault ||  _AddMod_Data.ValoreDefault == "True"}
                            errorText={_AddMod_Data.msgErrorIDTabellaSorgente}
                            onChange={(event, index, value) => this.handleOnToggleAddModify(event, value, "ValoreDefault")}>
                              <MenuItem value={true}  primaryText={LABEL_True[USERLANGUAGE]}/>
                              <MenuItem value={false} primaryText={LABEL_False[USERLANGUAGE]}/>
                          </SelectField>
                      </Col>
                    </Row>
                    || _AddMod_Data.TipoCampo.ID === 6 && //TABELLARE
                    <Row className="line-bottom">
                      <Col xs4={1}> 
                          <SelectField
                            floatingLabelText={LABEL_Choose_Table[USERLANGUAGE]}
                            value={_AddMod_Data.IDTabellaSorgente}
                            errorText={_AddMod_Data.msgErrorIDTabellaSorgente}
                            onChange={this.handleOnChangeAddModifyTabella}>
                              {  this.props.tabelleList && this.props.tabelleList.map( tabella => <MenuItem key={tabella.IDMaster} value={tabella.IDMaster} primaryText={tabella.Nome}/>  ) }
                          </SelectField>
                      </Col>
                        <Col xs4={1}>
                        { _AddMod_Data.IDTabellaSorgente !== null && 
                          <SelectField
                            floatingLabelText={LABEL_Choose_Field[USERLANGUAGE]}
                            value={_AddMod_Data.IDColonna}
                            errorText={_AddMod_Data.msgErrorIDColonna}
                            onChange={this.handleOnChangeAddModifyCampo}>
                              {  this.props.addModifyCampiList && this.props.addModifyCampiList.map( campo => <MenuItem key={campo.IDMaster} value={campo.IDMaster} primaryText={campo.Nome}/>  ) }
                          </SelectField>
                        }
                      </Col>
                    </Row>
                  }
                  <Row style={{marginTop: "50px"}}>
                    <Col xs4={1}>
                      <Toggle
                        label    = {LABEL_EditableInWeighing[USERLANGUAGE]}
                        style    = { styles.toggle}
                        toggled  = { _AddMod_Data.ModificabileInPesata }
                        onToggle = { (obj, checked) => this.handleOnToggleAddModify(obj, checked, "ModificabileInPesata") }
                      />
                    </Col>
                    <Col xs4={1}></Col>
                    <Col xs4={1}>
                      <Toggle
                        label    = {LABEL_Required[USERLANGUAGE]}
                        style    = { styles.toggle }
                        toggled  = { _AddMod_Data.Obbligatorio }
                        onToggle = { (obj, checked) => this.handleOnToggleAddModify(obj, checked, "Obbligatorio") }
                      />
                    </Col>
                  </Row>
              </Grid>
            </Dialog>
            
            <Dialog
              title={LABEL_Filters[USERLANGUAGE]}
              actions={filterDialogAction}
              modal={true}
              contentStyle={styles.filterDialog}
              open={this.state.filterDialog.opened || false}
            >
              <Grid>
                <Row>
                  <Col sm12={2}>
                    <div className="margin-top-25px">{LABEL_Editable[USERLANGUAGE]}</div>
                  </Col>
                  <Col sm12={3} className="line-bottom">
                    <RadioButtonGroup name="shipSpeed"
                      defaultSelected={this.state.filterDialog.data === null ? -1 : this.state.filterDialog.data.Modificabile}
                      onChange={(event, toggle) => this.handleFilterToggle(event, toggle, "Modificabile", LABEL_Editable[USERLANGUAGE])} >
                      <RadioButton value={0}  label={LABEL_Yes[USERLANGUAGE]} />
                      <RadioButton value={1}  label={LABEL_No[USERLANGUAGE]} />
                      <RadioButton value={-1} label={LABEL_All[USERLANGUAGE]} />
                    </RadioButtonGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm12={2}>
                    <div className="margin-top-25px">{LABEL_Required[USERLANGUAGE]}</div>
                  </Col>
                  <Col sm12={3} className="line-bottom">
                    <RadioButtonGroup name="shipSpeed" 
                      defaultSelected={this.state.filterDialog.data === null ? -1 : this.state.filterDialog.data.Obbligatorio} 
                      onChange={(event, toggle) => this.handleFilterToggle(event, toggle, "Obbligatorio", LABEL_Required[USERLANGUAGE])} >
                      <RadioButton value={0}  label={LABEL_Yes[USERLANGUAGE]}/>
                      <RadioButton value={1}  label={LABEL_No[USERLANGUAGE]} />
                      <RadioButton value={-1} label={LABEL_All[USERLANGUAGE]} />
                    </RadioButtonGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm12={2}>
                    <div className="margin-top-25px">{LABEL_Deleted[USERLANGUAGE]}</div>
                  </Col>
                  <Col sm12={3} className="line-bottom">
                    <RadioButtonGroup name="shipSpeed" 
                      defaultSelected={this.state.filterDialog.data === null ? -1 : this.state.filterDialog.data.Cancellato}
                      onChange={(event, toggle) => this.handleFilterToggle(event, toggle, "Cancellato", LABEL_Deleted[USERLANGUAGE])} >
                      <RadioButton value={0}  label={LABEL_Yes[USERLANGUAGE]} />
                      <RadioButton value={1}  label={LABEL_No[USERLANGUAGE]} />
                      <RadioButton value={-1} label={LABEL_All[USERLANGUAGE]} />
                    </RadioButtonGroup>
                  </Col>
                </Row>
              </Grid>
            </Dialog>

            {/*    ((((((((((     COMPILAZIONE VALORI TABELLA  -  - DIALOG      ))))))))))    */}
            <Dialog
              title={LABEL_FillTable[USERLANGUAGE]}
              actions={fillTableAction}
              autoScrollBodyContent={true}
              modal={true}
              contentStyle={styles.filterDialog}
              open={this.props.fillTableOpen}>
                  {this.props.campiPersonalizzatiCol.length === 1 &&
                      this.state.selectedList.length === 0 && USERINFO.Role.ID != ROLES.OPERATOR_ID &&
                      <Col sm12={12}>
                        <div>{LABEL_ColumnsNotFound[USERLANGUAGE]}<RaisedButton className="button-table" icon={<IconAdd/>} onClick={() => {this.fillTableClose() ; this.handleOpenAddModify() } } buttonStyle={STYLES.sg_Button} /></div>
                      </Col>
                    }
                  <div className="table-container">
                    <table>
                      
                      <tbody>
                        <tr>
                          {this.props.campiPersonalizzatiCol &&
                            this.props.campiPersonalizzatiCol.map( (row, index) => {
                              var isDelete = index === 0; //Se e' la colonna dove vado a mettere i bidoncini
                              var style = isDelete ? { color : "#6b9add", border : "none", padding: "30px"} : {color : "none"}
                              return (
                                <th key={index} style={style}>{ row.Nome }</th>
                              )
                            })
                          }
                        </tr>
                        { //Genero il numero delle righe
                          rowGeneratedTable.map( 
                            (row, index) => (
                              <tr key = {index}>
                                {
                                  //MAPPO I CAMPI PERSONALIZZATI
                                  this.props.campiPersonalizzatiCol &&
                                  this.props.campiPersonalizzatiCol.map( 
                                    (campo, col) => {
                                      var error     = this.getErrorFormCampo(campo.IDMaster, row);
                                      var tipoCampo = campo && campo.TipoCampo && campo.TipoCampo.ID;
                                      var x         = this._getCampoFromList(campo && campo.IDMaster, row);
                                      if(x && x.Cancellato) return;
                                     
                                      switch(tipoCampo){
                                        case -1: 
                                        var isDeleted =this._rowIsDeleted(row)
                                                return(
                                                    <td style={{border: "0px"}}  key={index}>
                                                      { row < rowGeneratedTable[rowGeneratedTable.length - 1] && !isDeleted && 
                                                        <div style={{margin: "0 auto", width: "min-content"}}>
                                                          <IconDelete onClick="delete" style={{cursor: "pointer"}} onClick = {() => { this.setState({ toDoDeleteRowNumber : row, dialogDeleteTableRowOpen: true}) }}/>
                                                        </div>}
                                                    </td>
                                                )
                                        case 1: return(
                                                  <td  key={index}>
                                                    <Badge className="error-badge" badgeContent={error||""} style={{backgroud: error == null ? "white" : "red"}}>
                                                      <input 
                                                        type="text" placeholder={campo && campo.TipoCampo && campo.TipoCampo.Nome} 
                                                        value={this.getValueFromCampo(campo.IDMaster, row) || ""}
                                                        onChange={event => { this.props.dispatch(handleOnTableValueChange(this.props.campiTabellaList, event.target.value, campo, row )); this.forceUpdate()}}/>
                                                    </Badge>
                                                  </td>
                                                )
                                        case 2:
                                        case 4: 
                                                return(
                                                  <td  key={index}>
                                                    <Badge className="error-badge"  badgeContent={""} color="#00FF00">
                                                      <input 
                                                        type="number" placeholder={campo && campo.TipoCampo && campo.TipoCampo.Nome} 
                                                        value={this.getValueFromCampo(campo.IDMaster, row) || ""} 
                                                        onChange={event => { this.props.dispatch(handleOnTableValueChange(this.props.campiTabellaList, event.target.value, campo, row )); this.forceUpdate()}}/>
                                                    </Badge>
                                                  </td>
                                                )
                                        case 5: // DATA
                                                return(
                                                  <td  key={index}>
                                                    <DatePicker
                                                      autoOk    = {this.state.autoOk}
                                                      onChange  = {(event, date) => { this.props.dispatch(handleOnTableValueChange(this.props.campiTabellaList, date, campo, row )); this.forceUpdate()}}
                                                      value     = {this.getValueFromCampo(campo.IDMaster, row) || {}}
                                                      placeholder  = {"data"}
                                                    />
                                                  </td>
                                                )
                                        case 3: //BOOLEAN
                                                return(
                                                  <td  key={index}>
                                                    <Toggle
                                                      style    = { styles.toggle }
                                                      toggled  = { this.getValueFromCampo(campo.IDMaster, row) || false}
                                                      onToggle= { (obj, checked) => { this.props.dispatch(handleOnTableValueChange(this.props.campiTabellaList, checked, campo, row )); this.forceUpdate()}}
                                                    />
                                                  </td>
                                                )
                                        case 6: 
                                        case 7:
                                                return(
                                                  <td key={index} style={{textAlign: "center", color: "black"}} onClick={() => this.onSelectTableValue(this.props.campiTabellaList, campo, row )}>
                                                    {this.getValueFromCampo(campo.IDMaster, row)}
                                                  </td>
                                                )
                                      }
                                    }
                                  )
                                  
                                }
                              </tr>
                            )
                          )
                        }
                      </tbody>
                      
                    </table>
                  </div>
            </Dialog>

            <ConfirmDialog 
                title        = { LABEL_Delete[USERLANGUAGE] }
                opened       = { this.state.dialogDeleteTableRowOpen || false}
                confirmLabel = { LABEL_Confirm[USERLANGUAGE]} 
                cancelLabel  = { LABEL_Cancel[USERLANGUAGE]}
                onCancel     = { () => this.setState({dialogDeleteTableRowOpen: false}) }
                body         = { LABEL_DIALOG_DELETE_Body[USERLANGUAGE] }
              onConfirm    = { () => {this.props.dispatch(onDeleteFieldsRow(this.props.campiTabellaList, this.state.toDoDeleteRowNumber)); this.setState({dialogDeleteTableRowOpen: false}); setTimeout(this.forceUpdate, 200)}}/>
           
            <ConfirmDialog 
                title        = { LABEL_Delete + ": "+ (this.state.selectedObj && this.state.selectedObj.Nome) }
                opened       = { this.state.showDeleteDialog || false }
                confirmLabel = { LABEL_Confirm[USERLANGUAGE]}
                cancelLabel  = { LABEL_Cancel[USERLANGUAGE]}
                onCancel     = { () => this.setState({showDeleteDialog: false}) }
                body         = {LABEL_DIALOG_DELETE_Body[USERLANGUAGE] + "" + (this.state.selectedObj && this.state.selectedObj.Nome)}
                onConfirm    = { this._deleteRow }/>
            
            <ConfirmDialog 
              title        = { LABEL_Choose_Value[USERLANGUAGE] }
              opened       = { this.state.dialogSelectTableValue.opened || false }
              confirmLabel = { LABEL_Cancel[USERLANGUAGE] }
              cancelLabel  = { LABEL_Cancel[USERLANGUAGE] }
              onCancel     = { null }
              body         = { this.state.dialogSelectTableValue.body }
              onConfirm    = { this.state.dialogSelectTableValue.onCancel }/>
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { campiPersonalizzatiReducer } = state;
  const { isFetching, isAuthenticated, campiPersonalizzatiList, toRefreshOnRender, errorMessage, holdingList, fillTableOpen,
          campiTabellaList, campiTabellaModifyIndexes, tableColumnValues, campiPersonalizzatiCol, tabelleList, addModifyCampiList} = campiPersonalizzatiReducer;
  return {
    isFetching,
    campiPersonalizzatiList,
    campiPersonalizzatiCol,
    isAuthenticated,
    toRefreshOnRender,
    errorMessage,
    holdingList,
    tabelleList,
    fillTableOpen,
    campiTabellaList,
    campiTabellaModifyIndexes,
    addModifyCampiList,
    tableColumnValues
  };
}

export default connect(mapStateToProps)(CampiPersonalizzati);


// WEBPACK FOOTER //
// ./src/Containers/Campi.js